import $ from "jquery";

import { processMarkdown } from "../utils/processMarkdown";

$(() => {
  for (const content of document.querySelectorAll(".markdown-body")) {
    processMarkdown(content);
  }
});
